var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_291_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_275_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1269_",
    d: "M8,5.31c-3.84,0-7.98-0.83-7.98-2.66C0.02,0.83,4.16,0,8,0s7.98,0.83,7.98,2.66 C15.98,4.48,11.84,5.31,8,5.31z M8,1C3.48,1,1.02,2.09,1.02,2.66S3.48,4.31,8,4.31s6.98-1.09,6.98-1.66S12.52,1,8,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_294_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1268_",
    d: "M8,10.55c-3.84,0-7.98-0.83-7.98-2.66h1c0,0.56,2.46,1.66,6.98,1.66s6.98-1.09,6.98-1.66h1 C15.98,9.72,11.84,10.55,8,10.55z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_292_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1267_",
    d: "M8,16c-3.84,0-7.98-0.83-7.98-2.66h1C1.02,13.91,3.48,15,8,15s6.98-1.09,6.98-1.66h1 C15.98,15.17,11.84,16,8,16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_289_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1266_",
    x: 0.02,
    y: 2.66,
    width: 1,
    height: 11.03
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_290_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1265_",
    x: 14.98,
    y: 2.66,
    width: 1,
    height: 11.03
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataObjects);
export default __webpack_public_path__ + "static/media/DataObjects.7a8f5d02df50392793ba098c54430558.svg";
export { ForwardRef as ReactComponent };